export const CARD_NUMBER_INVALID = 'cf93cf86-f1ee-4400-9317-d2469d0f2a22'
export const CARD_NOT_FOUND_AT_TLS = '204cb17d-b2d0-40d9-b128-acc7342826aa'
export const CARD_LOCALLY_BLACKLISTED = '211c59ac-6065-4821-a24f-10dd10e714a6'
export const CARD_HAS_WRONG_TYPE = 'b7d41216-96a2-4b22-9cd0-6ef4567ea400'
export const CARD_NOT_ACTIVE_AT_TLS = '544ee6e5-4a66-43fc-af9e-79ddce62c4d5'
export const CARD_HAS_EXPIRED = '1508e51b-d303-4b15-a158-353768b9653f'
export const CUSTOMER_GROUP_NOT_MATCH_CARD_HOLDER = '0a8d98af-ce9b-4389-8f4f-56912c82a877'
export const TARIFF_NOT_PERMITTED_FOR_CARD = '648ab969-142a-4120-86c9-dcd4399fdc3a'
export const VALUE_SHOULD_NOT_BE_BLANK = 'c1051bb4-d103-4f74-8988-acbcafc7fdc3'
export const VALUE_SHOULD_NOT_BE_NULL = 'ad32d13f-c3d4-423b-909a-857b961eb720'
export const NO_MATCHING_PRICE_FOR_CONFIGURATION = '7fd34506-f2f3-4dcd-a07f-4cc3b6f7a47e'
export const ORDER_HAS_DUPLICATE_ITEMS = 'd6054ae1-c811-417a-9ef7-9f93e2d1bed6'
export const ORDER_IS_MIXED = '4d140e6b-b6af-463c-aa49-c73fd67e6f15'
export const ORDER_NOT_ELIGIBLE_FOR_SPECIAL_SALE = '0b55c956-6903-40bb-bf0b-0fa146d412d1'
export const ORDER_HAS_MIXED_SHOP_ITEMS = '4fefa342-63d2-4556-af9d-13917967a9ff'
export const BASE_PROPOSITION_ALREADY_REGISTERED = '14950463-3e4c-42f4-b264-5694577504c9'
export const ORDER_HAS_PRODUCT_CONFLICT_CRITICAL = 'f3aa3b45-7c4a-4f8b-b789-dcd04c15b59a'
export const ORDER_HAS_PRODUCT_CONFLICT_HIGH = '81e44aab-171c-4e90-9729-4349950880f2'
export const ORDER_HAS_PRODUCT_CONFLICT_MEDIUM = '0fbcc410-1cb4-4b33-a3a3-d322a5a38b75'
export const ORDER_STATUS_PAID = 'paid'
export const ORDER_STATUS_ACCEPTED = 'accepted'
export const ORDER_STATUS_DRAFT = 'draft'
export const ORDER_STATUS_AWAITING_PAYMENT = 'awaitingPayment'
export const ORDER_STATUS_FAILED_PAYMENT = 'failedPayment'
export const ORDER_STATUS_UNKNOWN = 'unknown'
export const ORDER_VALIDATION_STAGE_CART = 'cart'
export const ORDER_VALIDATION_STAGE_CUSTOMER_DETAILS = 'customer-details'
export const ORDER_SENT_RESULT_SUCCESS = 'success'
export const ORDER_SENT_RESULT_FAILURE = 'failure'



// WEBPACK FOOTER //
// ./src/order-api/order-api-client-constants.js